export default __webpack_public_path__ + "static/media/mark-guifa.fbc27438.png";